import React from 'react';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { GT_COLORS } from './constants';

interface WatchButtonProps {
    watching: boolean;
    onClick: (e: React.MouseEvent) => void;
    size?: 'small' | 'medium';
}

export const WatchButton: React.FC<WatchButtonProps> = ({ watching, onClick, size = 'small' }) => {
    const isSmall = size === 'small';
    const iconSize = isSmall ? 16 : 18;

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onClick(e);
            }}
            title={watching ? 'You are receiving alerts' : 'Receive safety alerts'}
            style={{
                background: watching ? GT_COLORS.primaryLight : GT_COLORS.cardBg,
                border: `1px solid ${watching ? GT_COLORS.primary : GT_COLORS.borderInput}`,
                cursor: 'pointer',
                padding: isSmall ? '3px 8px 3px 5px' : '6px 12px 6px 8px',
                borderRadius: '6px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: isSmall ? '3px' : '4px',
                fontFamily: 'inherit',
                fontSize: isSmall ? '12px' : '14px',
                fontWeight: 500,
                color: watching ? GT_COLORS.primary : GT_COLORS.textMuted,
                whiteSpace: 'nowrap',
                transition: 'all .15s',
            }}
        >
            {watching ? (
                <NotificationsActiveIcon sx={{ fontSize: iconSize, color: GT_COLORS.primary }} />
            ) : (
                <NotificationsNoneIcon sx={{ fontSize: iconSize, color: GT_COLORS.textFaint }} />
            )}
            {watching ? 'Alerts On' : 'Get Alerts'}
        </button>
    );
};
